/* global require */
import Vue from "vue";

export default Vue.component("zippy", {
  props: [ "value", "title", "name" ],

  data() {
    return {
    };
  },

  watch: {
    desktopTabOpen(newVal) {
      this.mobileTabsOpen = [ newVal ];
    }
  },

  methods: {
    buttonClicked() {
      if (this.open) {
        this.$emit("input", this.value.filter(e => e !== this.name));
      } else {
        this.$emit("input", this.value.concat(this.name));
      }
    }
  },

  computed: {
    open() {
      return this.value.indexOf(this.name) !== -1;
    }
  },

  template: require("./templates/zippy.html"),
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/zippy.js